export const tableColumnsTopCreators = [
  {
    Header: "Domaine",
    accessor: "competence",
  },
  {
    Header: "Mesure",
    accessor: "score",
  },
];
